import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoggedInGuard} from './logged-in.guard';
import {LoginService} from './login.service';
import {Session} from '../domain/session';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoginComponent} from './login/login.component';
import {NotLoggedInGuard} from './not-logged-in.guard';
import {MatIconModule} from '@angular/material/icon';
import {ComponentModule} from '../component/component.module';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ComponentModule,
  ],
  exports: [
    LoginComponent
  ],
  declarations: [
    LoginComponent
  ],
  providers: [
    LoggedInGuard,
    NotLoggedInGuard,
    LoginService,
    Session
  ]
})
export class LoginModule {
}
